export default __webpack_public_path__ + "static/media/ql_14.5ddefb59.png";